import React from 'react';
import './badge.scss'

type BadgeProps = {
    type: 'error' | 'warning' | 'success';
    text: string;
}

const Badge = ({ type, text}: BadgeProps ) => {
    return(
        <div style={{display: 'inline-block'}}>
            <div className={type}>
                <span className={`circle`}></span>
                <span>{text.toUpperCase()}</span>
            </div>
        </div>
        
    )
}

export default Badge;